import request from "@/utils/request";

/**
 * 查询房产计算规则列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function queryCalcRules(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/roomCalculation.queryRoomCalculation',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取规则详情
 * @param {Object} params { ruleId, communityId }
 * @returns {Promise}
 */
export function getCalcRuleDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/roomCalculation.getRoomCalculationById',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 新增房产计算规则
 * @param {Object} data 规则数据
 * @returns {Promise}
 */
export function addCalcRule(data) {
  return request({
    url: "/roomCalculation.saveRoomCalculation",
    method: "post",
    data,
  });
}

/**
 * 修改房产计算规则
 * @param {Object} data 规则数据
 * @returns {Promise}
 */
export function updateCalcRule(data) {
  return request({
    url: "/roomCalculation.updateRoomCalculation",
    method: "post",
    data,
  });
}

/**
 * 删除房产计算规则
 * @param {Object} data { ruleId, communityId }
 * @returns {Promise}
 */
export function deleteCalcRule(data) {
  return request({
    url: "/roomCalculation.deleteRoomCalculation",
    method: "post",
    data,
  });
}


/**
 * 新增查询接口（示例：查询房产配置项列表）
 * @param {Object} params 查询参数（如：communityId, page, size）
 * @returns {Promise}
 */
export function getHouseListByRuleId(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/roomCalculation.queryRuleRelRooms',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 新增接口（示例：新增房产配置项）
 * @param {Object} data 配置项数据（如：configName, configValue, communityId）
 * @returns {Promise}
 */
export function relateRuleToRooms(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/roomCalculation.addRuleRelRoom',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 新增删除接口（示例：删除房产配置项）
 * @param {Object} data { configId, communityId }
 * @returns {Promise}
 */
export function unRelateHouseFromRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/roomCalculation.deleteRuleRelRoom',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询房屋列表
export function queryRuleRelRooms(params) {
  return new Promise((resolve, reject) => {
    request({
      url: "/room.queryRuleRelRooms",
      method: "get",
      params,
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}